import { useSelector } from 'react-redux';
import { selectComponentHeight, selectComponentPadding } from 'store/entities/ui/selectors';
import { GLOBAL_ADMIN_TYPOGRAPHY_HEADER_HEIGHT, STATIC_TABLE_MARGIN } from './const';
import { useIsAdminModule } from 'utils/hooks/useIsAdminModule';

const cleanNumber = (value: unknown) => {
  const num = Number(value);
  return Number.isNaN(num) ? 0 : num;
};

export const useTableHeight = () => {
  const headerHeight = useSelector(selectComponentHeight('header'));
  const breadcrumbsHeight = useSelector(selectComponentHeight('breadcrumbs'));
  const userModulesAgendaListHeaderHeight = useSelector(selectComponentHeight('user-modules-agenda-list-header'));
  const userModulesAgendaListTabsHeight = useSelector(selectComponentHeight('user-modules-agenda-list-tabs'));
  const userHeliosModulesAgendaListHeaderHeight = useSelector(selectComponentHeight('user-helios-modules-agenda-list-header'));
  const tablePaginatorHeight = useSelector(selectComponentHeight('table-paginator'));
  const layoutContentPadding = useSelector(selectComponentPadding('layout-content'));
  const userContactsGroupsHeight = useSelector(selectComponentHeight('user-contacts-groups'));

  const numHeaderHeight = cleanNumber(headerHeight);
  const numBreadcrumbsHeight = cleanNumber(breadcrumbsHeight);
  const numUserModulesAgendaListHeaderHeight = cleanNumber(userModulesAgendaListHeaderHeight);
  const numUserModulesAgendaListTabsHeight = cleanNumber(userModulesAgendaListTabsHeight);
  const numUserHeliosModulesAgendaListHeaderHeight = cleanNumber(userHeliosModulesAgendaListHeaderHeight);
  const numTablePaginatorHeight = cleanNumber(tablePaginatorHeight);
  const numLayoutContentPaddingTop = cleanNumber(layoutContentPadding?.top);
  const numLayoutContentPaddingBottom = cleanNumber(layoutContentPadding?.bottom);
  const numUserContactsGroupsHeight = cleanNumber(userContactsGroupsHeight);

  const isAdmin = useIsAdminModule();
  const adminGlobalTypographyHeader = isAdmin ? GLOBAL_ADMIN_TYPOGRAPHY_HEADER_HEIGHT : 0;

  const totalComponentsHeight =
    numLayoutContentPaddingTop +
    numLayoutContentPaddingBottom +
    STATIC_TABLE_MARGIN +
    numHeaderHeight +
    numBreadcrumbsHeight +
    numUserModulesAgendaListHeaderHeight +
    numUserModulesAgendaListTabsHeight +
    numUserHeliosModulesAgendaListHeaderHeight +
    numTablePaginatorHeight +
    numUserContactsGroupsHeight +
    adminGlobalTypographyHeader;

  return totalComponentsHeight;
};
